<template>
    <div>
        <!-- 页面固定头部 -->
        <a-anchor :getContainer="getModuleContainer" style="width:100%">
            <!-- 面包屑组件 -->
            <FGBreadHead></FGBreadHead>
        </a-anchor>
        <a-page-header class="fun-panel" title="单位调查情况" :sub-title="subTitle" @back="onBack">
            <template v-slot:extra>
                <a-button :loading="loading || saving" type="primary" @click="onSave(0)">保存</a-button>
                <a-button :loading="loading || saving" type="primary" @click="onSave(1)">提交</a-button>
            </template>
            <a-divider></a-divider>
            <a-layout>
                <a-spin :spinning="loading">
                    <a-form ref="form" class="fun-edit-form" :label-col="{ span: 12 }" :wrapper-col="{ span: 10 }" style="padding:10px 20px;">
                        <FGCollapsiblePanel title="单位及咨询师就业情况调查表">
                            <a-row :gutter="[0, 6]">
                                <a-col :span="12">
                                    <a-form-item label="登记表编号">
                                        <a-input ref="djbbh" v-model="editData.djbbh" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="登记日期">
                                        <a-input ref="djrq" v-model="editData.djrq" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="单位名称">
                                        <a-input ref="dwmc" v-model="editData.dwmc" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="咨询师人数" required>
                                        <a-input-number ref="zxsrs" v-model="editData.zxsrs" :min="0" :precision="0" style="width:100%" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="咨询师流动性" required>
                                        <FGDictSelectCN ref="zxsldx" dictNo="HY200201" v-model="editData.zxsldx" placeholder="" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="咨询师新增情况(18年)" required>
                                        <FGDictSelectCN ref="zxsxzqk18" dictNo="HY200202" v-model="editData.zxsxzqk18" placeholder="" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="咨询师新增情况(19年)" required>
                                        <FGDictSelectCN ref="zxsxzqk19" dictNo="HY200202" v-model="editData.zxsxzqk19" placeholder="" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="咨询师新增情况(20年)" required>
                                        <FGDictSelectCN ref="zxsxzqk20" dictNo="HY200202" v-model="editData.zxsxzqk20" placeholder="" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12" v-if="isShow_zxsxzqk18">
                                    <a-form-item label="新增人数(18年)" required>
                                        <a-input-number ref="zxsxzrs18" v-model="editData.zxsxzrs18" :min="0" :precision="0" style="width:100%" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12" v-if="isShow_zxsxzqk19">
                                    <a-form-item label="新增人数(19年)" required>
                                        <a-input-number ref="zxsxzrs19" v-model="editData.zxsxzrs19" :min="0" :precision="0" style="width:100%" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12" v-if="isShow_zxsxzqk20">
                                    <a-form-item label="新增人数(20年)" required>
                                        <a-input-number ref="zxsxzrs20" v-model="editData.zxsxzrs20" :min="0" :precision="0" style="width:100%" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="咨询业资信评价证书等级" required>
                                        <FGDictSelectCN ref="zxpjzsdj" dictNo="HY200203" v-model="editData.zxpjzsdj" placeholder="" mode="multiple" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="参加培训人次数占职工人数比例(18年)" required>
                                        <a-input-number
                                            ref="cjpxrsbl18"
                                            v-model="editData.cjpxrsbl18"
                                            style="width:100%"
                                            :min="0"
                                            :max="100"
                                            :formatter="(value) => `${value}%`"
                                            :parser="(value) => value.replace('%', '')"
                                            :precision="2"
                                        />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="参加培训人次数占职工人数比例(19年)" required>
                                        <a-input-number
                                            ref="cjpxrsbl19"
                                            v-model="editData.cjpxrsbl19"
                                            :min="0"
                                            :max="100"
                                            :formatter="(value) => `${value}%`"
                                            :parser="(value) => value.replace('%', '')"
                                            style="width:100%"
                                            :precision="2"
                                        />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="参加培训人次数占职工人数比例(20年)" required>
                                        <a-input-number
                                            ref="cjpxrsbl20"
                                            v-model="editData.cjpxrsbl20"
                                            :min="0"
                                            :max="100"
                                            :formatter="(value) => `${value}%`"
                                            :parser="(value) => value.replace('%', '')"
                                            style="width:100%"
                                            :precision="2"
                                        />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="是否还参加其他职业培训(除规定学时外)" required>
                                        <FGDictSelectCN ref="sfcjqtpx" dictNo="HY200204" v-model="editData.sfcjqtpx" placeholder="" mode="multiple" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="启用执业专用章人数占比(18年)" required>
                                        <a-input-number
                                            ref="qyzyzyzrsbl18"
                                            v-model="editData.qyzyzyzrsbl18"
                                            :min="0"
                                            :max="100"
                                            :formatter="(value) => `${value}%`"
                                            :parser="(value) => value.replace('%', '')"
                                            style="width:100%"
                                            :precision="2"
                                        />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="启用执业专用章人数占比(19年)" required>
                                        <a-input-number
                                            ref="qyzyzyzrsbl19"
                                            v-model="editData.qyzyzyzrsbl19"
                                            :min="0"
                                            :max="100"
                                            :formatter="(value) => `${value}%`"
                                            :parser="(value) => value.replace('%', '')"
                                            style="width:100%"
                                            :precision="2"
                                        />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="启用执业专用章人数占比(20年)" required>
                                        <a-input-number
                                            ref="qyzyzyzrsbl20"
                                            v-model="editData.qyzyzyzrsbl20"
                                            :min="0"
                                            :max="100"
                                            :formatter="(value) => `${value}%`"
                                            :parser="(value) => value.replace('%', '')"
                                            style="width:100%"
                                            :precision="2"
                                        />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="咨询人员配备占达标比例" required>
                                        <FGDictSelectCN ref="zxrypbzdbbl" dictNo="HY200205" v-model="editData.zxrypbzdbbl" placeholder="" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="24">
                                    <a-form-item label="18年企业被表彰情况(政府机构、行业等)" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }" required>
                                        <a-textarea ref="qybbzqk18" v-model="editData.qybbzqk18" :rows="2" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="24">
                                    <a-form-item label="19年企业被表彰情况(政府机构、行业等)" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }" required>
                                        <a-textarea ref="qybbzqk19" v-model="editData.qybbzqk19" :rows="2" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="24">
                                    <a-form-item label="20年企业被表彰情况(政府机构、行业等)" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }" required>
                                        <a-textarea ref="qybbzqk20" v-model="editData.qybbzqk20" :rows="2" />
                                    </a-form-item>
                                </a-col>
                            </a-row>
                        </FGCollapsiblePanel>
                        <FGCollapsiblePanel title="业务合约执行情况表">
                            <a-row :gutter="[0, 6]">
                                <a-col :span="12">
                                    <a-form-item label="合同执行甲方满意度(18年)" required>
                                        <FGDictSelectCN ref="htzxjfmyd18" dictNo="HY200206" v-model="editData.htzxjfmyd18" placeholder="" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="不满意原因(18年)">
                                        <a-input ref="htzxjfbmyyy18" v-model="editData.htzxjfbmyyy18" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="合同执行甲方满意度(19年)" required>
                                        <FGDictSelectCN ref="htzxjfmyd19" dictNo="HY200206" v-model="editData.htzxjfmyd19" placeholder="" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="不满意原因(19年)">
                                        <a-input ref="htzxjfbmyyy19" v-model="editData.htzxjfbmyyy19" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="合同执行甲方满意度(20年)" required>
                                        <FGDictSelectCN ref="htzxjfmyd20" dictNo="HY200206" v-model="editData.htzxjfmyd20" placeholder="" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="不满意原因(20年)">
                                        <a-input ref="htzxjfbmyyy20" v-model="editData.htzxjfbmyyy20" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="合同未执行或不到位情况(18年)" required>
                                        <FGDictSelectCN ref="htwzxhbdwqk18" dictNo="HY200207" v-model="editData.htwzxhbdwqk18" placeholder="" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="主要原因(18年)" required>
                                        <FGDictSelectCN ref="zyyy18" dictNo="HY200208" v-model="editData.zyyy18" placeholder="" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="24">
                                    <a-form-item label="原因阐述(18年)" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }">
                                        <a-textarea ref="yycs18" v-model="editData.yycs18" :rows="1" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="合同未执行或不到位情况(19年)" required>
                                        <FGDictSelectCN ref="htwzxhbdwqk19" dictNo="HY200207" v-model="editData.htwzxhbdwqk19" placeholder="" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="主要原因(19年)" required>
                                        <FGDictSelectCN ref="zyyy19" dictNo="HY200208" v-model="editData.zyyy19" placeholder="" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="24">
                                    <a-form-item label="原因阐述(19年)" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }">
                                        <a-textarea ref="yycs19" v-model="editData.yycs19" :rows="1" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="合同未执行或不到位情况(20年)" required>
                                        <FGDictSelectCN ref="htwzxhbdwqk20" dictNo="HY200207" v-model="editData.htwzxhbdwqk20" placeholder="" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="主要原因(20年)" required>
                                        <FGDictSelectCN ref="zyyy20" dictNo="HY200208" v-model="editData.zyyy20" placeholder="" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="24">
                                    <a-form-item label="原因阐述(20年)" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }">
                                        <a-textarea ref="yycs20" v-model="editData.yycs20" :rows="1" />
                                    </a-form-item>
                                </a-col>
                            </a-row>
                        </FGCollapsiblePanel>
                        <FGCollapsiblePanel title="质量保障体系建设情况">
                            <a-row :gutter="[0, 6]">
                                <a-col :span="12">
                                    <a-form-item label="项目接收或投标前有无相关标准、制度、规范等" required>
                                        <FGDictSelectCN ref="xmjstbqbzbj" dictNo="HY200202" v-model="editData.xmjstbqbzbj" placeholder="" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="如有，列出相关标准、制度、规范名称">
                                        <a-input ref="xmjstbqbz" v-model="editData.xmjstbqbz" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="项目执行(事中)有无相关标准、制度、规范等" required>
                                        <FGDictSelectCN ref="xmzxbzbj" dictNo="HY200202" v-model="editData.xmzxbzbj" placeholder="" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="如有，列出相关标准、制度、规范名称">
                                        <a-input ref="xmzxbz" v-model="editData.xmzxbz" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="项目完成后(事后)有无相关标准、制度、规范等" required>
                                        <FGDictSelectCN ref="xmwcbzbj" dictNo="HY200202" v-model="editData.xmwcbzbj" placeholder="" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="如有，列出相关标准、制度、规范名称">
                                        <a-input ref="xmwcbz" v-model="editData.xmwcbz" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="其他有无相关标准、制度、规范等" required>
                                        <FGDictSelectCN ref="qtbzbj" dictNo="HY200202" v-model="editData.qtbzbj" placeholder="" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="如有，列出相关标准、制度、规范名称">
                                        <a-input ref="qtbz" v-model="editData.qtbz" />
                                    </a-form-item>
                                </a-col>
                            </a-row>
                        </FGCollapsiblePanel>
                        <FGCollapsiblePanel title="企业发展面临的主要问题">
                            <a-row :gutter="[0, 6]">
                                <a-col :span="12">
                                    <a-form-item label="行业发展与市场存在问题" required>
                                        <FGDictSelectCN ref="hyfzyscczwt" dictNo="HY200209" v-model="editData.hyfzyscczwt" placeholder="" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="24">
                                    <a-form-item label="典型事例描述" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }" required>
                                        <a-textarea ref="hyfzyscdxsl" v-model="editData.hyfzyscdxsl" :rows="2" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="24">
                                    <a-form-item label="对策与建议" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }" required>
                                        <a-textarea ref="hyfzyscjy" v-model="editData.hyfzyscjy" :rows="2" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="人力资源、单位资信等存在问题" required>
                                        <FGDictSelectCN ref="rlzyczwt" dictNo="HY200209" v-model="editData.rlzyczwt" placeholder="" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="24">
                                    <a-form-item label="典型事例描述" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }" required>
                                        <a-textarea ref="rlzydxsl" v-model="editData.rlzydxsl" :rows="2" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="24">
                                    <a-form-item label="对策与建议" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }" required>
                                        <a-textarea ref="rlzyjy" v-model="editData.rlzyjy" :rows="2" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="行业不正当竞争和地方保护等主要问题存在问题" required>
                                        <FGDictSelectCN ref="hybzdjzczwt" dictNo="HY200209" v-model="editData.hybzdjzczwt" placeholder="" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="24">
                                    <a-form-item label="典型事例描述" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }" required>
                                        <a-textarea ref="hybzdjzdxsl" v-model="editData.hybzdjzdxsl" :rows="2" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="24">
                                    <a-form-item label="对策与建议" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }" required>
                                        <a-textarea ref="hybzdjzjy" v-model="editData.hybzdjzjy" :rows="2" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="其他存在问题" required>
                                        <FGDictSelectCN ref="qtczwt" dictNo="HY200209" v-model="editData.qtczwt" placeholder="" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="24">
                                    <a-form-item label="典型事例描述" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }" required>
                                        <a-textarea ref="qtdxsl" v-model="editData.qtdxsl" :rows="2" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="24">
                                    <a-form-item label="对策与建议" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }" required>
                                        <a-textarea ref="qtjy" v-model="editData.qtjy" :rows="2" />
                                    </a-form-item>
                                </a-col>
                            </a-row>
                        </FGCollapsiblePanel>
                        <FGCollapsiblePanel title="协会工作评价表">
                            <a-row :gutter="[0, 6]">
                                <a-col :span="12">
                                    <a-form-item label="行业规范运作(18年)" required>
                                        <FGDictSelectCN ref="hygfyz18" dictNo="HY200206" v-model="editData.hygfyz18" placeholder="" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="行业规范运作(19年)" required>
                                        <FGDictSelectCN ref="hygfyz19" dictNo="HY200206" v-model="editData.hygfyz19" placeholder="" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="行业规范运作(20年)" required>
                                        <FGDictSelectCN ref="hygfyz20" dictNo="HY200206" v-model="editData.hygfyz20" placeholder="" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="24">
                                    <a-form-item label="行业规范运作建议与要求" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }" required>
                                        <a-textarea ref="hygfyzjyyyq" v-model="editData.hygfyzjyyyq" :rows="2" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="组织培训与业务指导(18年)" required>
                                        <FGDictSelectCN ref="zzpxywzd18" dictNo="HY200206" v-model="editData.zzpxywzd18" placeholder="" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="组织培训与业务指导(19年)" required>
                                        <FGDictSelectCN ref="zzpxywzd19" dictNo="HY200206" v-model="editData.zzpxywzd19" placeholder="" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="组织培训与业务指导(20年)" required>
                                        <FGDictSelectCN ref="zzpxywzd20" dictNo="HY200206" v-model="editData.zzpxywzd20" placeholder="" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="24">
                                    <a-form-item label="组织培训与业务指导建议与要求" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }" required>
                                        <a-textarea ref="zzpxywzdjyyyq" v-model="editData.zzpxywzdjyyyq" :rows="2" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="了解与反映诉求(18年)" required>
                                        <FGDictSelectCN ref="ljfysq18" dictNo="HY200206" v-model="editData.ljfysq18" placeholder="" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="了解与反映诉求(19年)" required>
                                        <FGDictSelectCN ref="ljfysq19" dictNo="HY200206" v-model="editData.ljfysq19" placeholder="" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="了解与反映诉求(20年)" required>
                                        <FGDictSelectCN ref="ljfysq20" dictNo="HY200206" v-model="editData.ljfysq20" placeholder="" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="24">
                                    <a-form-item label="了解与反映诉求建议与要求" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }" required>
                                        <a-textarea ref="ljfysqjyyyq" v-model="editData.ljfysqjyyyq" :rows="2" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="协会服务能力提升(18年)" required>
                                        <FGDictSelectCN ref="xhfwnlts18" dictNo="HY200206" v-model="editData.xhfwnlts18" placeholder="" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="协会服务能力提升(19年)" required>
                                        <FGDictSelectCN ref="xhfwnlts19" dictNo="HY200206" v-model="editData.xhfwnlts19" placeholder="" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="协会服务能力提升(20年)" required>
                                        <FGDictSelectCN ref="xhfwnlts20" dictNo="HY200206" v-model="editData.xhfwnlts20" placeholder="" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="24">
                                    <a-form-item label="协会服务能力提升建议与要求" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }" required>
                                        <a-textarea ref="xhfwnltsjyyyq" v-model="editData.xhfwnltsjyyyq" :rows="2" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="请您对协会总体工作给予评价(18年)" required>
                                        <FGDictSelectCN ref="gzpj18" dictNo="HY200206" v-model="editData.gzpj18" placeholder="" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="请您对协会总体工作给予评价(19年)" required>
                                        <FGDictSelectCN ref="gzpj19" dictNo="HY200206" v-model="editData.gzpj19" placeholder="" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="请您对协会总体工作给予评价(20年)" required>
                                        <FGDictSelectCN ref="gzpj20" dictNo="HY200206" v-model="editData.gzpj20" placeholder="" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="24">
                                    <a-form-item label="对协会总体工作评价建议与要求" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }" required>
                                        <a-textarea ref="gzpjjyyyq" v-model="editData.gzpjjyyyq" :rows="2" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="录入部门">
                                        <a-input ref="bmmc" v-model="editData.bmmc" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="录入人">
                                        <a-input ref="lrr" v-model="editData.lrr" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="录入时间">
                                        <a-input ref="lrrq" v-model="editData.lrrq" disabled />
                                    </a-form-item>
                                </a-col>
                            </a-row>
                            <a-row :gutter="[0, 6]">
                                <a-col :span="24">
                                    <a-form-item label="工作情况" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }">
                                        <a-textarea
                                            v-model="editData.gzqk"
                                            placeholder="请围绕配合政府部门监督、配合行业及社会监督以及履行社会责任三方面来谈谈企业近三年的工作情况"
                                            :rows="3"
                                        />
                                    </a-form-item>
                                </a-col>
                            </a-row>
                        </FGCollapsiblePanel>
                    </a-form>
                </a-spin>
                <!-- 操作日志 -->
                <OperLog ref="operlog" :operLogProps="operLogProps"></OperLog>
            </a-layout>
        </a-page-header>
    </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters: userMapGetters } = createNamespacedHelpers("user");
export default {
    name: "DwdcqkdjEdit",
    props: ["showEdit", "dataId"],
    data() {
        return {
            // 避免重复点击提交
            saving: false,
            // 主表数据
            editData: {},
            editDataLoading: false,
            isShowIcon: true,
            isShow_zymc: false,
            // 流程跟踪参数
            operLogProps: {
                visible: false,
                billid: null
            },
            isShow_zxsxzqk18: false,
            isShow_zxsxzqk19: false,
            isShow_zxsxzqk20: false
        };
    },
    computed: {
        ...userMapGetters(["getUserInfo", "getToken"]),
        subTitle() {
            return this.dataId ? "编辑" : "新增";
        },
        // 是否显示编辑界面
        editIsVisible: {
            get() {
                return this.showEdit;
            },
            set(newVal) {
                this.$emit("update:showEdit", newVal);
            }
        },
        // 当前编辑记录id
        editDataId: {
            get() {
                return this.dataId;
            },
            set(newVal) {
                this.$emit("update:dataId", newVal);
            }
        },
        loading() {
            return this.editDataLoading;
        }
    },
    watch: {
        "editData.zxsxzqk18": function(val, oldval) {
            if (val !== undefined) {
                if (val !== oldval) {
                    if (val === "有") {
                        this.isShow_zxsxzqk18 = true;
                    } else {
                        this.isShow_zxsxzqk18 = false;
                    }
                }
            }
        },
        "editData.zxsxzqk19": function(val, oldval) {
            if (val !== undefined) {
                if (val !== oldval) {
                    if (val === "有") {
                        this.isShow_zxsxzqk19 = true;
                    } else {
                        this.isShow_zxsxzqk19 = false;
                    }
                }
            }
        },
        "editData.zxsxzqk20": function(val, oldval) {
            if (val !== undefined) {
                if (val !== oldval) {
                    if (val === "有") {
                        this.isShow_zxsxzqk20 = true;
                    } else {
                        this.isShow_zxsxzqk20 = false;
                    }
                }
            }
        }
    },
    activated() {
        if (!this.editDataId) {
            this.$FG_http
                .post(
                    "./api/main/hydcgl/dwdc/selectDwxxByYhid",
                    {
                        yhid: this.getUserInfo.id
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.editData = data.data;
                            // 新增，设置默认值
                            this.editData = {
                                id: this.$FG_util.uuid(),
                                isnew: true,
                                djlxid: "DWDCQK",
                                djlx: "单位调查情况",
                                djbbh: "",
                                djrq: this.$FG_util.formatDate(new Date(), "YYYY-MM-DD"),
                                dwid: data.data.id,
                                dwbh: data.data.dwbh,
                                dwmc: data.data.dwmc,
                                zxsrs: 0,
                                cjpxrsbl18: 0,
                                cjpxrsbl19: 0,
                                cjpxrsbl20: 0,
                                qyzyzyzrsbl18: 0,
                                qyzyzyzrsbl19: 0,
                                qyzyzyzrsbl20: 0,
                                bmid: this.getUserInfo.org_id,
                                yhid: this.getUserInfo.id,
                                ryid: this.getUserInfo.personnel_id,
                                bmmc: this.getUserInfo.org_name,
                                lrr: this.getUserInfo.personnel_name,
                                lrrq: this.$FG_util.formatDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
                                djzt: "制定"
                            };
                            this.$FG_helper.handleNewBillCode("DJBBH").then((val) => {
                                this.editData.djbbh = val;
                            });
                        } else {
                            // 加载的数据不存在则提示错误并关闭编辑窗口
                            this.$FG_message.error("P0002").then(() => (this.editIsVisible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则关闭弹窗
                        this.editIsVisible = false;
                    }
                });
        } else {
            // 修改，加载数据
            this.loadData();
        }
        // 设置光标位置
        this.$nextTick(() => {
            this.$refs.zxsrs.focus();
        });
    },
    methods: {
        search_zymc(row) {
            this.isShow_zymc = true;
            this.select_zymc = row;
        },
        saveEvent_zymc(val, currentrow) {
            if (val && val.length > 0) {
                this.select_zymc.zyid = val[0][0].ID;
                this.select_zymc.zymc = val[0][0].ZYMC;
            }
        },
        // 根据id查询需要编辑的数据
        loadData() {
            this.editData = {};
            this.editDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/hydcgl/dwdc/selectById",
                    {
                        id: this.dataId
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.editData = data.data;
                            if (data.data.zxpjzsdj && data.data.zxpjzsdj.length !== 0) {
                                this.editData.zxpjzsdj = data.data.zxpjzsdj.split(",");
                            }
                            if (data.data.sfcjqtpx && data.data.sfcjqtpx.length !== 0) {
                                this.editData.sfcjqtpx = data.data.sfcjqtpx.split(",");
                            }
                            this.initOperLog();
                        } else {
                            // 加载的数据不存在则提示错误并关闭编辑窗口
                            this.$FG_message.error("P0002").then(() => (this.editIsVisible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则关闭弹窗
                        this.editIsVisible = false;
                    }
                });
        },
        //提交form
        onSave(btnType) {
            if (btnType === 1) {
                // 表单校验
                if (!this.editData.zxsrs && this.editData.zxsrs !== 0) {
                    this.$FG_message.error("P0001", "咨询师人数").then(() => this.$refs.zxsrs.focus());
                    return;
                }
                if (!this.editData.zxsldx) {
                    this.$FG_message.error("P0001", "咨询师流动性").then(() => this.$refs.zxsldx.focus());
                    return;
                }
                if (!this.editData.zxsxzqk18) {
                    this.$FG_message.error("P0001", "咨询师新增情况(18年)").then(() => this.$refs.zxsxzqk18.focus());
                    return;
                }
                if (!this.editData.zxsxzqk19) {
                    this.$FG_message.error("P0001", "咨询师新增情况(19年)").then(() => this.$refs.zxsxzqk19.focus());
                    return;
                }
                if (!this.editData.zxsxzqk20) {
                    this.$FG_message.error("P0001", "咨询师新增情况(20年)").then(() => this.$refs.zxsxzqk20.focus());
                    return;
                }
                if (this.editData.zxsxzqk18 === "有") {
                    if (!this.editData.zxsxzrs18 && this.editData.zxsxzrs18 !== 0) {
                        this.$FG_message.error("P0001", "新增人数(18年)").then(() => this.$refs.zxsxzrs18.focus());
                        return;
                    }
                }
                if (this.editData.zxsxzqk19 === "有") {
                    if (!this.editData.zxsxzrs19 && this.editData.zxsxzrs19 !== 0) {
                        this.$FG_message.error("P0001", "新增人数(19年)").then(() => this.$refs.zxsxzrs19.focus());
                        return;
                    }
                }
                if (this.editData.zxsxzqk20 === "有") {
                    if (!this.editData.zxsxzrs20 && this.editData.zxsxzrs20 !== 0) {
                        this.$FG_message.error("P0001", "新增人数(20年)").then(() => this.$refs.zxsxzrs20.focus());
                        return;
                    }
                }

                if (!this.editData.zxpjzsdj || this.editData.zxpjzsdj.length === 0) {
                    this.$FG_message.error("P0001", "咨询业资信评价证书等级").then(() => this.$refs.zxpjzsdj.focus());
                    return;
                }
                if (!this.editData.cjpxrsbl18 && this.editData.cjpxrsbl18 !== 0) {
                    this.$FG_message.error("P0001", "参加培训人次数占职工人数比例(18年)").then(() => this.$refs.cjpxrsbl18.focus());
                    return;
                }
                if (!this.editData.cjpxrsbl19 && this.editData.cjpxrsbl19 !== 0) {
                    this.$FG_message.error("P0001", "参加培训人次数占职工人数比例(19年)").then(() => this.$refs.cjpxrsbl19.focus());
                    return;
                }
                if (!this.editData.cjpxrsbl20 && this.editData.cjpxrsbl20 !== 0) {
                    this.$FG_message.error("P0001", "参加培训人次数占职工人数比例(20年)").then(() => this.$refs.cjpxrsbl20.focus());
                    return;
                }
                if (!this.editData.sfcjqtpx || this.editData.sfcjqtpx.length === 0) {
                    this.$FG_message.error("P0001", "是否还参加其他职业培训(除规定学时外)").then(() => this.$refs.sfcjqtpx.focus());
                    return;
                }
                if (!this.editData.qyzyzyzrsbl18 && this.editData.qyzyzyzrsbl18 !== 0) {
                    this.$FG_message.error("P0001", "启用执业专用章人数占比(18年)").then(() => this.$refs.qyzyzyzrsbl18.focus());
                    return;
                }
                if (!this.editData.qyzyzyzrsbl19 && this.editData.qyzyzyzrsbl19 !== 0) {
                    this.$FG_message.error("P0001", "启用执业专用章人数占比(19年)").then(() => this.$refs.qyzyzyzrsbl19.focus());
                    return;
                }
                if (!this.editData.qyzyzyzrsbl20 && this.editData.qyzyzyzrsbl20 !== 0) {
                    this.$FG_message.error("P0001", "启用执业专用章人数占比(20年)").then(() => this.$refs.qyzyzyzrsbl20.focus());
                    return;
                }
                if (!this.editData.zxrypbzdbbl) {
                    this.$FG_message.error("P0001", "咨询人员配备占达标比例").then(() => this.$refs.zxrypbzdbbl.focus());
                    return;
                }
                if (!this.editData.qybbzqk18) {
                    this.$FG_message.error("P0001", "18年企业被表彰情况(政府机构、行业等)").then(() => this.$refs.qybbzqk18.focus());
                    return;
                }
                if (!this.editData.qybbzqk19) {
                    this.$FG_message.error("P0001", "19年企业被表彰情况(政府机构、行业等)").then(() => this.$refs.qybbzqk19.focus());
                    return;
                }
                if (!this.editData.qybbzqk20) {
                    this.$FG_message.error("P0001", "20年企业被表彰情况(政府机构、行业等)").then(() => this.$refs.qybbzqk20.focus());
                    return;
                }
                if (!this.editData.htzxjfmyd18) {
                    this.$FG_message.error("P0001", "合同执行甲方满意度(18年)").then(() => this.$refs.htzxjfmyd18.focus());
                    return;
                }
                if (!this.editData.htzxjfmyd19) {
                    this.$FG_message.error("P0001", "合同执行甲方满意度(19年)").then(() => this.$refs.htzxjfmyd19.focus());
                    return;
                }
                if (!this.editData.htzxjfmyd20) {
                    this.$FG_message.error("P0001", "合同执行甲方满意度(20年)").then(() => this.$refs.htzxjfmyd20.focus());
                    return;
                }
                if (!this.editData.htwzxhbdwqk18) {
                    this.$FG_message.error("P0001", "合同未执行或不到位情况(18年)").then(() => this.$refs.htwzxhbdwqk18.focus());
                    return;
                }
                if (!this.editData.htwzxhbdwqk19) {
                    this.$FG_message.error("P0001", "合同未执行或不到位情况(19年)").then(() => this.$refs.htwzxhbdwqk19.focus());
                    return;
                }
                if (!this.editData.htwzxhbdwqk20) {
                    this.$FG_message.error("P0001", "合同未执行或不到位情况(20年)").then(() => this.$refs.htwzxhbdwqk20.focus());
                    return;
                }
                if (!this.editData.zyyy18) {
                    this.$FG_message.error("P0001", "主要原因(18年)").then(() => this.$refs.zyyy18.focus());
                    return;
                }
                if (!this.editData.zyyy19) {
                    this.$FG_message.error("P0001", "主要原因(19年)").then(() => this.$refs.zyyy19.focus());
                    return;
                }
                if (!this.editData.zyyy20) {
                    this.$FG_message.error("P0001", "主要原因(20年)").then(() => this.$refs.zyyy20.focus());
                    return;
                }
                if (!this.editData.xmjstbqbzbj) {
                    this.$FG_message.error("P0001", "项目接收或投标前有无相关标准、制度、规范等").then(() => this.$refs.xmjstbqbzbj.focus());
                    return;
                }
                if (!this.editData.xmzxbzbj) {
                    this.$FG_message.error("P0001", "项目执行(事中)有无相关标准、制度、规范等").then(() => this.$refs.xmzxbzbj.focus());
                    return;
                }
                if (!this.editData.xmwcbzbj) {
                    this.$FG_message.error("P0001", "项目完成后(事后)有无相关标准、制度、规范等").then(() => this.$refs.xmwcbzbj.focus());
                    return;
                }
                if (!this.editData.qtbzbj) {
                    this.$FG_message.error("P0001", "其他有无相关标准、制度、规范等").then(() => this.$refs.qtbzbj.focus());
                    return;
                }
                if (!this.editData.hyfzyscczwt) {
                    this.$FG_message.error("P0001", "行业发展与市场存在问题").then(() => this.$refs.hyfzyscczwt.focus());
                    return;
                }
                if (!this.editData.hyfzyscdxsl) {
                    this.$FG_message.error("P0001", "行业发展与市场典型事例描述").then(() => this.$refs.hyfzyscdxsl.focus());
                    return;
                }
                if (!this.editData.hyfzyscjy) {
                    this.$FG_message.error("P0001", "行业发展与市场对策与建议").then(() => this.$refs.hyfzyscjy.focus());
                    return;
                }
                if (!this.editData.rlzyczwt) {
                    this.$FG_message.error("P0001", "人力资源、单位资信等存在问题").then(() => this.$refs.rlzyczwt.focus());
                    return;
                }
                if (!this.editData.rlzydxsl) {
                    this.$FG_message.error("P0001", "人力资源、单位资信等典型事例描述").then(() => this.$refs.rlzydxsl.focus());
                    return;
                }
                if (!this.editData.rlzyjy) {
                    this.$FG_message.error("P0001", "人力资源、单位资信等对策与建议").then(() => this.$refs.rlzyjy.focus());
                    return;
                }
                if (!this.editData.hybzdjzczwt) {
                    this.$FG_message.error("P0001", "行业不正当竞争和地方保护等主要问题存在问题").then(() => this.$refs.hybzdjzczwt.focus());
                    return;
                }
                if (!this.editData.hybzdjzdxsl) {
                    this.$FG_message.error("P0001", "行业不正当竞争和地方保护等主要问题典型事例描述").then(() => this.$refs.hybzdjzdxsl.focus());
                    return;
                }
                if (!this.editData.hybzdjzjy) {
                    this.$FG_message.error("P0001", "行业不正当竞争和地方保护等主要问题对策与建议").then(() => this.$refs.hybzdjzjy.focus());
                    return;
                }
                if (!this.editData.qtczwt) {
                    this.$FG_message.error("P0001", "其他存在问题").then(() => this.$refs.qtczwt.focus());
                    return;
                }
                if (!this.editData.qtdxsl) {
                    this.$FG_message.error("P0001", "其他典型事例描述").then(() => this.$refs.qtdxsl.focus());
                    return;
                }
                if (!this.editData.qtjy) {
                    this.$FG_message.error("P0001", "其他对策与建议").then(() => this.$refs.qtjy.focus());
                    return;
                }
                if (!this.editData.hygfyz18) {
                    this.$FG_message.error("P0001", "行业规范运作(18年)").then(() => this.$refs.hygfyz18.focus());
                    return;
                }
                if (!this.editData.hygfyz19) {
                    this.$FG_message.error("P0001", "行业规范运作(19年)").then(() => this.$refs.hygfyz19.focus());
                    return;
                }
                if (!this.editData.hygfyz20) {
                    this.$FG_message.error("P0001", "行业规范运作(20年)").then(() => this.$refs.hygfyz20.focus());
                    return;
                }
                if (!this.editData.hygfyzjyyyq) {
                    this.$FG_message.error("P0001", "行业规范运作建议与要求").then(() => this.$refs.hygfyzjyyyq.focus());
                    return;
                }
                if (!this.editData.zzpxywzd18) {
                    this.$FG_message.error("P0001", "组织培训与业务指导(18年)").then(() => this.$refs.zzpxywzd18.focus());
                    return;
                }
                if (!this.editData.zzpxywzd19) {
                    this.$FG_message.error("P0001", "组织培训与业务指导(19年)").then(() => this.$refs.zzpxywzd19.focus());
                    return;
                }
                if (!this.editData.zzpxywzd20) {
                    this.$FG_message.error("P0001", "组织培训与业务指导(20年)").then(() => this.$refs.zzpxywzd20.focus());
                    return;
                }
                if (!this.editData.zzpxywzdjyyyq) {
                    this.$FG_message.error("P0001", "组织培训与业务指导建议与要求").then(() => this.$refs.zzpxywzdjyyyq.focus());
                    return;
                }
                if (!this.editData.ljfysq18) {
                    this.$FG_message.error("P0001", "了解与反映诉求(18年)").then(() => this.$refs.ljfysq18.focus());
                    return;
                }
                if (!this.editData.ljfysq19) {
                    this.$FG_message.error("P0001", "了解与反映诉求(19年)").then(() => this.$refs.ljfysq19.focus());
                    return;
                }
                if (!this.editData.ljfysq20) {
                    this.$FG_message.error("P0001", "了解与反映诉求(20年)").then(() => this.$refs.ljfysq20.focus());
                    return;
                }
                if (!this.editData.ljfysqjyyyq) {
                    this.$FG_message.error("P0001", "了解与反映诉求建议与要求").then(() => this.$refs.ljfysqjyyyq.focus());
                    return;
                }
                if (!this.editData.xhfwnlts18) {
                    this.$FG_message.error("P0001", "协会服务能力提升(18年)").then(() => this.$refs.xhfwnlts18.focus());
                    return;
                }
                if (!this.editData.xhfwnlts19) {
                    this.$FG_message.error("P0001", "协会服务能力提升(19年)").then(() => this.$refs.xhfwnlts19.focus());
                    return;
                }
                if (!this.editData.xhfwnlts20) {
                    this.$FG_message.error("P0001", "协会服务能力提升(20年)").then(() => this.$refs.xhfwnlts20.focus());
                    return;
                }
                if (!this.editData.xhfwnltsjyyyq) {
                    this.$FG_message.error("P0001", "协会服务能力提升建议与要求").then(() => this.$refs.xhfwnltsjyyyq.focus());
                    return;
                }
                if (!this.editData.gzpj18) {
                    this.$FG_message.error("P0001", "请您对协会总体工作给予评价(18年)").then(() => this.$refs.gzpj18.focus());
                    return;
                }
                if (!this.editData.gzpj19) {
                    this.$FG_message.error("P0001", "请您对协会总体工作给予评价(19年)").then(() => this.$refs.gzpj19.focus());
                    return;
                }
                if (!this.editData.gzpj20) {
                    this.$FG_message.error("P0001", "请您对协会总体工作给予评价(20年)").then(() => this.$refs.gzpj20.focus());
                    return;
                }
                if (!this.editData.gzpjjyyyq) {
                    this.$FG_message.error("P0001", "对协会总体工作评价建议与要求").then(() => this.$refs.gzpjjyyyq.focus());
                    return;
                }
                if (!this.editData.gzqk) {
                    this.$FG_message
                        .error("P0001", "请围绕配合政府部门监督、配合行业及社会监督以及履行社会责任三方面来谈谈企业近三年的工作情况")
                        .then(() => this.$refs.gzqk.focus());
                    return;
                }
            }
            // 保存操作

            if (this.editData.zxpjzsdj && this.editData.zxpjzsdj.length !== 0) {
                this.editData.zxpjzsdj = this.editData.zxpjzsdj.join(",");
            }
            if (this.editData.sfcjqtpx && this.editData.sfcjqtpx.length !== 0) {
                this.editData.sfcjqtpx = this.editData.sfcjqtpx.join(",");
            }
            this.saving = true;
            this.$FG_http
                .post(
                    "./api/main/hydcgl/dwdc/save",
                    {
                        data: this.editData
                    },
                    { showSuccess: btnType === 1 ? false : true }
                )
                .then(({ success, data, errMsg }) => {
                    this.saving = false;
                    if (success) {
                        // 设置当前行
                        this.editDataId = this.editData.id;
                        this.editData.isnew = false;
                    } else {
                        this.$refs.zxsrs.focus();
                    }
                })
                .then(() => {
                    if (this.editDataId) {
                        if (btnType === 1) {
                            if (this.editData.zxpjzsdj && this.editData.zxpjzsdj.length !== 0) {
                                this.editData.zxpjzsdj = this.editData.zxpjzsdj.split(",");
                            }
                            if (this.editData.sfcjqtpx && this.editData.sfcjqtpx.length !== 0) {
                                this.editData.sfcjqtpx = this.editData.sfcjqtpx.split(",");
                            }
                            this.submit();
                        } else {
                            this.loadData();
                        }
                    }
                });
        },
        // 返回列表
        onBack() {
            this.editIsVisible = false;
        },
        //提交
        submit(type) {
            this.$FG_message.confirm("P0000", "提交").then((type) => {
                if (type === "ok") {
                    this.$FG_http
                        .post("./api/main/hydcgl/dwdc/submit", {
                            id: this.editData.id
                        })
                        .then(({ success, data, errMsg }) => {
                            this.tableDataLoading = false;
                            if (success) {
                                // 设置当前行
                                this.editDataId = this.editData.id;
                                //提交之后跳转主页面
                                this.editIsVisible = false;
                            } else {
                                this.$refs.zxsrs.focus();
                            }
                        });
                }
            });
        },
        initOperLog() {
            this.operLogProps.visible = true;
            this.operLogProps.billid = this.editData.id;
        }
    }
};
</script>
